<template>
  <div class="device-page">
    <div class="container">
      <div class="chart-block">
        <div class="item">
          <img src="../assets/img/sjtj-title.png" class="tit" style="height:50px" />
          <div class="chart-box">
            <v-chart :options="options_sjtj" />
          </div>
        </div>
        <div class="item">
          <img src="../assets/img/gzhz-title.png" class="tit" style="height:50px" />
          <div class="chart-box">
            <v-chart :options="options_gzhz" />
            <!-- <device-gzhz></device-gzhz> -->
          </div>
        </div>
        <div class="item">
          <img src="../assets/img/sjhz-title.png" class="tit" style="height:50px" />
          <div class="chart-box">
            <v-chart :options="options_gzsjhz" />
          </div>
        </div>
        <div class="item">
          <img src="../assets/img/sbfh-title.png" class="tit" style="height:50px" />
          <div style="height:100%;width:100%;">
            <device-sbfh :echarts08Data="charts8Data"></device-sbfh>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts";
import DatePicker from "vue2-datepicker";
// 设备负荷
import DeviceSbfh from "../home/home/echarts3";
//故障汇总
import DeviceGzhz from "../home/home/echarts5";

export default {
  name: "",
  components: {
    DatePicker,
    DeviceSbfh,
    DeviceGzhz
  },
  props: {
    sjtjLists: {
      type: Array,
      default: () => {
        return [];
      }
    },
    gzsjhzLists: {
      type: Array,
      default: () => {
        return [];
      }
    },
    gzhzLists: {
      type: Array,
      default: () => {
        return [];
      }
    },
    charts8Data: {
      type: Array,
      default: () => {
        return [
          {
            EquipmentNo: "SC03",
            UnExcuteCount: 11,
            UnExcuteTime: 10.61954887218045,
            ExcutedCount: 399,
            ExcutedTime: 6.42
          },
          {
            EquipmentNo: "SC04",
            UnExcuteCount: 13,
            UnExcuteTime: 17.387500000000003,
            ExcutedCount: 384,
            ExcutedTime: 8.56
          },
          {
            EquipmentNo: "SC05",
            UnExcuteCount: 10,
            UnExcuteTime: 10.508021390374331,
            ExcutedCount: 374,
            ExcutedTime: 6.55
          }
        ];
      }
    }
  },
  data() {
    return {
      // 时间统计
      sjtjList: [
        {
          lists: [
            {
              label: ["历史运行总时长"],
              count: [22795, 22078, 9456]
            },
            {
              label: ["最近一次运行总时长"],
              count: [21337, 21337, 9456]
            }
          ],
          field: ["1区"]
        }
      ],
      options_sjtj: {}, // 时间统计
      // 故障汇总
      gzhzList: [
        {
          PLC: "PFK",
          StationName: "1002拆垛机",
          TotalDuration_Stn: 2092,
          Percentages: 0.206
        },
        {
          PLC: "PFK",
          StationName: "1119",
          TotalDuration_Stn: 208,
          Percentages: 0.02
        },
        {
          PLC: "PFK",
          StationName: "1114",
          TotalDuration_Stn: 1,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1118",
          TotalDuration_Stn: 66,
          Percentages: 0.006
        },
        {
          PLC: "PFK",
          StationName: "1004夹抱机",
          TotalDuration_Stn: 2,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1077提升机",
          TotalDuration_Stn: 1108,
          Percentages: 0.109
        },
        {
          PLC: "PFK",
          StationName: "1057_1",
          TotalDuration_Stn: 0,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1109提升机",
          TotalDuration_Stn: 2154,
          Percentages: 0.212
        },
        {
          PLC: "PFK",
          StationName: "1113提升机",
          TotalDuration_Stn: 2318,
          Percentages: 0.228
        },
        {
          PLC: "PFK",
          StationName: "1047",
          TotalDuration_Stn: 15,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1062_1",
          TotalDuration_Stn: 28,
          Percentages: 0.003
        },
        {
          PLC: "PFK",
          StationName: "1111",
          TotalDuration_Stn: 13,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1068",
          TotalDuration_Stn: 0,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1001",
          TotalDuration_Stn: 7,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1074夹抱机",
          TotalDuration_Stn: 2093,
          Percentages: 0.206
        },
        {
          PLC: "PFK",
          StationName: "1012",
          TotalDuration_Stn: 2,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1005_1",
          TotalDuration_Stn: 0,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1110",
          TotalDuration_Stn: 5,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1112",
          TotalDuration_Stn: 8,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1064",
          TotalDuration_Stn: 28,
          Percentages: 0.003
        },
        {
          PLC: "PFK",
          StationName: "1115",
          TotalDuration_Stn: 13,
          Percentages: 0.001
        }
      ],
      options_gzhz: {}, // 故障汇总
      // 故障时间汇总
      gzsjhzList: [
        {
          PLC: "PFK",
          StationName: "1002拆垛机",
          TotalDuration_Stn: 2092,
          Percentages: 0.206
        },
        {
          PLC: "PFK",
          StationName: "1119",
          TotalDuration_Stn: 208,
          Percentages: 0.02
        },
        {
          PLC: "PFK",
          StationName: "1114",
          TotalDuration_Stn: 1,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1118",
          TotalDuration_Stn: 66,
          Percentages: 0.006
        },
        {
          PLC: "PFK",
          StationName: "1004夹抱机",
          TotalDuration_Stn: 2,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1077提升机",
          TotalDuration_Stn: 1108,
          Percentages: 0.109
        },
        {
          PLC: "PFK",
          StationName: "1057_1",
          TotalDuration_Stn: 0,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1109提升机",
          TotalDuration_Stn: 2154,
          Percentages: 0.212
        },
        {
          PLC: "PFK",
          StationName: "1113提升机",
          TotalDuration_Stn: 2318,
          Percentages: 0.228
        },
        {
          PLC: "PFK",
          StationName: "1047",
          TotalDuration_Stn: 15,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1062_1",
          TotalDuration_Stn: 28,
          Percentages: 0.003
        },
        {
          PLC: "PFK",
          StationName: "1111",
          TotalDuration_Stn: 13,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1068",
          TotalDuration_Stn: 0,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1001",
          TotalDuration_Stn: 7,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1074夹抱机",
          TotalDuration_Stn: 2093,
          Percentages: 0.206
        },
        {
          PLC: "PFK",
          StationName: "1012",
          TotalDuration_Stn: 2,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1005_1",
          TotalDuration_Stn: 0,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1110",
          TotalDuration_Stn: 5,
          Percentages: 0.0
        },
        {
          PLC: "PFK",
          StationName: "1112",
          TotalDuration_Stn: 8,
          Percentages: 0.001
        },
        {
          PLC: "PFK",
          StationName: "1064",
          TotalDuration_Stn: 28,
          Percentages: 0.003
        },
        {
          PLC: "PFK",
          StationName: "1115",
          TotalDuration_Stn: 13,
          Percentages: 0.001
        }
      ],
      options_gzsjhz: {}, // 故障事件汇总
      echarts08Datas: this.charts8Data // 设备负荷
    };
  },
  mounted() {
    this.setOptionsSjtj();
    this.setOptionsGzsjhz();
    this.setOptionsGzhz();
  },
  watch: {
    sjtjLists: {
      handler(newval, oldval) {
        this.sjtjList = newval;
        console.log(this.sjtjList);
        this.setOptionsSjtj();
      },
      deep: true
    },
    gzsjhzLists: {
      handler(newValue, oldValue) {
        this.gzsjhzList = newValue;
        this.setOptionsGzsjhz();
      },
      deep: true
    },
    gzhzLists: {
      handler(newValue, oldValue) {
        this.gzhzList = newValue;
        this.setOptionsGzhz();
      },
      deep: true
    }
    // charts8Data: {
    //   handler(newValue, oldValue) {
    //     let newList=[];
    //     newValue.forEach(function(element) {
    //         let list = {
    //           "EquipmentNo":element.EquipmentNo,
    //           "ExcutedCount":element.ExcutedCount,
    //           "ExcutedTime":element.ExcutedTime,
    //           "UnExcuteCount":element.UnExcuteCount,
    //           "UnExcuteTime":element.UnExcuteTime.toFixed(2)
    //         }
    //         newList.push(list)
    //     });
    //     this.echarts08Datas = newList;
    //   }
    // }
  },
  methods: {
    setOptionsSjtj() {
      let self = this;
      //   let colors = this.$charts.colors.style_14;
      //   let chartsConf = this.$charts[window.CurrentTheme];
      //   let legendData = [];
      //   let xdata = [];
      //   let sdata = [];
      //   console.log(this.sjtjList)
      //   this.sjtjList.forEach( function(d, di) {
      //     console.log(d)
      //     d.lists.forEach( function(t, ti) {
      //       if(legendData.indexOf(t.label) == -1) {
      //         legendData.push(t.label);
      //       }
      //       if(di == 0) {  //
      //         let tmpdata = [];
      //         self.sjtjList.forEach( function(dd) {
      //           dd.lists.forEach( function(tt) {
      //             if(tt.label == t.label) {
      //               tmpdata.push(tt.count)
      //             }
      //           })
      //         });
      //         let stack = '';
      //         let markPoint = {
      //           data: [
      //             {type: 'max', name: '最大值'},
      //             {type: 'min', name: '最小值'}
      //           ]
      //         }
      //         let tmp = {
      //           name: t.label,
      //           type:'bar',
      //           barWidth: 15,//柱图宽度
      //           barGap: '50%',
      //           color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
      //             {offset: 0, color: colors[ti][0]}, {offset: 1, color: colors[ti][1]}
      //           ]),
      //           stack: stack,
      //           markPoint: markPoint,
      //           data: tmpdata
      //         }
      //         sdata.push(tmp)
      //       }
      //     });
      //     xdata.push(d.field);
      //   });

      this.options_sjtj = {
        // backgroundColor: "#091C3D",
        tooltip: {
          //提示框组件
          trigger: "axis",
          formatter: "{b}<br />{a0}: {c0}<br />{a1}: {c1}",
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985"
            }
          },
          textStyle: {
            color: "#fff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12
          }
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "10%",
          top: "30%",
          //	padding:'0 0 10 0',
          containLabel: true
        },
        legend: {
          //图例组件，颜色和名字
          right: "10%",
          top: "15%",
          itemGap: 16,
          itemWidth: 18,
          itemHeight: 10,
          data: [
            {
              name: "历史运行总时长"
              //icon:'image://../wwwroot/js/url2.png', //路径
            },
            {
              name: "最近一次运行总时长"
            }
          ],
          textStyle: {
            color: "#a8aab0",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12
          }
        },
        xAxis: [
          {
            type: "category",
            //	boundaryGap: true,//坐标轴两边留白
            data: [
              "1区",
              "2区",
              "3区"
            ],
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              //		interval: 0,//设置为 1，表示『隔一个标签显示一个标签』
              //	margin:15,
              textStyle: {
                color: "#078ceb",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 12
              },
              rotate: 50
            },
            axisTick: {
              //坐标轴刻度相关设置。
              show: false
            },
            axisLine: {
              //坐标轴轴线相关设置
              lineStyle: {
                color: "#fff",
                opacity: 0.2
              }
            },
            splitLine: {
              //坐标轴在 grid 区域中的分隔线。
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 5,
            axisLabel: {
              textStyle: {
                color: "#a8aab0",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 12
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#666"],
                opacity:0.3
              }
            }
          }
        ],
        series: [
          {
            name: "历史运行总时长",
            type: "bar",
            data: [
              22795,
              22078,
              9456
            ],
            barWidth: 10,
            barGap: 0, //柱间距离
            // label: {//图形上的文本标签
            //     normal: {
            //       show: true,
            //       position: 'top',
            //       textStyle: {
            //           color: '#a8aab0',
            //           fontStyle: 'normal',
            //           fontFamily: '微软雅黑',
            //           fontSize: 12,
            //       },
            //     },
            // },
            itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#5768EF"
                  },
                  {
                    offset: 1,
                    color: "#5768EF"
                  }
                ]),
                barBorderRadius: 50,
                borderWidth: 0
              }
            }
          },
          {
            name: "最近一次运行总时长",
            type: "bar",
            data: [21337, 21337, 9456],
            barWidth: 10,
            barGap: 0, //柱间距离
            // label: {//图形上的文本标签
            //     normal: {
            //       show: true,
            //       position: 'top',
            //       textStyle: {
            //           color: '#a8aab0',
            //           fontStyle: 'normal',
            //           fontFamily: '微软雅黑',
            //           fontSize: 12,
            //       },
            //     },
            // },
            itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#69CBF2"
                  },
                  {
                    offset: 1,
                    color: "#69CBF2"
                  }
                ]),
                barBorderRadius: 50,
                borderWidth: 0
              }
            }
          }
        ]
      };
    },
    setOptionsGzhz() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];
      var colora = [
        "#1c32c9",
        "#1cbacc",
        "#e64a3b",
        "#e1449b",
        "#43f45d",
        "#5948ff",
        "#ef5f47",
        "#42ffb1",
        "#8b7aff",
        "#fb9700"
      ];
      let gzhzData = this.gzhzList.slice(0, 10);
      gzhzData.forEach(function(l, li) {
        legendData.push(l.StationName);
        // console.log(l.StationName);
        // let color = colors[li][1];
        let color = colora[li];
        // console.log(color);
        let tmp = {
          value: l.TotalDuration_Stn,
          name: l.StationName,
          label: {
            color: "#000",
            fontSize: 14
          },
          itemStyle: {
            normal: {
              color: color
            }
          }
        };
        sdata.push(tmp);
      });
      this.options_gzhz = {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}次 ({d}%)",
          textStyle: {
            fontSize: 14
          }
        },

        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 30, 0],
          type: "scroll",
          textStyle: {
            color: "#000",
            fontSize: 14
          },
          data: legendData
        },
        //calculable : true,
        series: [
          {
            type: "pie",
            radius: ["24%", "40%"],
            center: ["50%", "48%"],
            //roseType : 'area',
            data: sdata
          }
        ]
      };
    },
    setOptionsGzsjhz() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];
      // console.log(this.gzsjhzList);
      this.gzsjhzList.forEach(function(l, li) {
        legendData.push(l.StationName);
        let value = Math.round((l.TotalDuration_Stn / 60) * 100) / 100;
        let color = colors[li][1];
        let tmp = {
          value: value,
          name: l.StationName,
          label: {
            color: "#000",
            fontSize: 14
          },
          itemStyle: {
            normal: {
              color: color
            }
          }
        };
        sdata.push(tmp);
      });
      this.options_gzsjhz = {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}min ({d}%)",
          textStyle: {
            fontSize: 14
          }
        },
        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 30, 0],
          type: "scroll",
          textStyle: {
            color: "#000",
            fontSize: 14
          },
          data: legendData
        },
        //calculable : true,
        series: [
          {
            type: "pie",
            radius: ["24%", "40%"],
            center: ["55%", "55%"],
            //roseType : 'area',
            data: sdata
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.device-page {
  width: 100%;
  height: 100%;
}
.item:first-child {
  padding: 60px 10px 0 30px;
  border-right: 1px solid #cae8ff;
  border-bottom: 1px solid #cae8ff;
  box-sizing: border-box;
}
.item:nth-child(2) {
  border-bottom: 1px solid #cae8ff;
  box-sizing: border-box;
}
.item:nth-child(3) {
  border-right: 1px solid #cae8ff;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceMaintain.vue